export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/56b90c2f-7af0-4836-bebc-00f914e390ab/images/abcf840f59eeb29c49909ddc91004a29159063ddd59a61949f3dd64638b50f2d.jpeg",
  eyewear: "https://static.prod-images.emergentagent.com/jobs/56b90c2f-7af0-4836-bebc-00f914e390ab/images/3a9046a78a1f290e186305b61c75085863c6722a7cb8696afcb79ff61e822f26.jpeg",
  imageBreak: "https://static.prod-images.emergentagent.com/jobs/56b90c2f-7af0-4836-bebc-00f914e390ab/images/dc53e9244fc89914f446ce2e56badcc01abb33577fc01429fc5962e6e9822cd9.jpeg",
  accessory: "https://static.prod-images.emergentagent.com/jobs/56b90c2f-7af0-4836-bebc-00f914e390ab/images/9ba5fc6ffe3a402ca3df6c2df1d7878b15fe6735c3c6f0b70b6b55c1aa57aeec.jpeg",
  texture: "https://static.prod-images.emergentagent.com/jobs/56b90c2f-7af0-4836-bebc-00f914e390ab/images/b067b1b9b25e0db642b1e060b4d61dae71cd877b81dae174c4465506b95a43b8.jpeg",
};

export const content = {
  en: {
    langName: "EN",
    tagline: "Coming soon",
    hero: {
      headline: "Brands worth discovering.",
      support:
        "We introduce and grow emerging sports, lifestyle and accessories brands in Colombia.",
      location: "Bogotá / Colombia",
      cta: "Brand partnerships",
      stamp: "MIDLOWS / 2026",
    },
    intro: {
      statement: ["Independent brands.", "Locally built."],
      paragraph:
        "MIDLOWS works with emerging global brands looking to enter and grow in Colombia. We combine market knowledge, wholesale, retail strategy, e-commerce and local brand development to build meaningful long-term presence.",
    },
    what: {
      headline: ["We don’t just distribute.", "We build markets."],
      items: [
        "Market Entry",
        "Wholesale",
        "Retail Placement",
        "Brand Development",
        "E-commerce",
        "Local Partnerships",
      ],
    },
    imageBreak: { label: "Sport / Outdoor / Lifestyle / Accessories" },
    network: {
      number: "42",
      suffix: "+",
      text: "Retail points across Colombia.",
      support: "Fashion / Travel Retail / Outdoor / Active Lifestyle / Marketplaces",
    },
    philosophy: {
      quote: "We like brands before everyone likes them.",
      sub: "We look for brands with a point of view, a strong product and the potential to become culturally relevant in our market.",
      small: "Find what’s next. Build it locally.",
    },
    marquee: "Selective — Connected — Emerging — Global — Local — ",
    brands: {
      headline: ["Looking at Colombia?", "Start here."],
      text: "MIDLOWS partners with emerging international brands to develop their presence in Colombia — from the first curated assortment to long-term market development.",
      cta: "Talk to MIDLOWS",
    },
    footer: {
      soon: "Full platform coming soon.",
      meta: ["Bogotá, CO", "Wholesale / Brand Partnerships", "© MIDLOWS 2026"],
    },
  },
  es: {
    langName: "ES",
    tagline: "Muy pronto",
    hero: {
      headline: "Marcas que vale la pena descubrir.",
      support:
        "Presentamos y hacemos crecer marcas emergentes de deporte, lifestyle y accesorios en Colombia.",
      location: "Bogotá / Colombia",
      cta: "Alianzas de marca",
      stamp: "MIDLOWS / 2026",
    },
    intro: {
      statement: ["Marcas independientes.", "Construidas localmente."],
      paragraph:
        "MIDLOWS trabaja con marcas globales emergentes que buscan entrar y crecer en Colombia. Combinamos conocimiento de mercado, mayoreo, estrategia retail, e-commerce y desarrollo de marca local para construir una presencia significativa y de largo plazo.",
    },
    what: {
      headline: ["No solo distribuimos.", "Construimos mercados."],
      items: [
        "Entrada al Mercado",
        "Mayoreo",
        "Ubicación Retail",
        "Desarrollo de Marca",
        "E-commerce",
        "Alianzas Locales",
      ],
    },
    imageBreak: { label: "Deporte / Outdoor / Lifestyle / Accesorios" },
    network: {
      number: "42",
      suffix: "+",
      text: "Puntos de venta en toda Colombia.",
      support: "Moda / Travel Retail / Outdoor / Active Lifestyle / Marketplaces",
    },
    philosophy: {
      quote: "Nos gustan las marcas antes de que le gusten a todos.",
      sub: "Buscamos marcas con un punto de vista, un producto fuerte y el potencial de volverse culturalmente relevantes en nuestro mercado.",
      small: "Encuentra lo que sigue. Constrúyelo localmente.",
    },
    marquee: "Selectivo — Conectado — Emergente — Global — Local — ",
    brands: {
      headline: ["¿Mirando hacia Colombia?", "Empieza aquí."],
      text: "MIDLOWS se asocia con marcas internacionales emergentes para desarrollar su presencia en Colombia — desde el primer surtido curado hasta el desarrollo de mercado a largo plazo.",
      cta: "Habla con MIDLOWS",
    },
    footer: {
      soon: "Plataforma completa muy pronto.",
      meta: ["Bogotá, CO", "Mayoreo / Alianzas de Marca", "© MIDLOWS 2026"],
    },
  },
};

export const EMAIL = "hello@midlows.com";
